<template>
    <div>

        <table class="table table-striped">
            <thead>
                <tr>
                    <th>Dealer Code</th>
                    <th>Dealer Name</th>
                    <th>On-Hand Stock</th>
                    <th>Assigned Stock</th>
                    <th>Mapping QR</th>
                    <th><i class="fas fa-cog"></i></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="dat in data">
                    <td>{{ dat.dealer_code }}</td>
                    <td>{{ dat.dealer_name }}</td>
                    <td>{{ numberWithCommas(dat.onhand_stock) }}</td>
                    <td>{{ numberWithCommas(dat.assigned_stock) }}</td>
                    <td>{{ numberWithCommas(dat.mapping_qr) }}</td>
                    <td>
                        <button
                            class="btn btn-outline-secondary"
                            title="Edit Assigned Stock"
                            @click="$emit('editAssingedStock', dat)"
                        >
                            <i class="fas fa-edit"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

    </div>
</template>

<script>
    export default {
        data () {
            return {
                
            }
        },
        props : ['data'],
        mounted () {

        },
        methods : {

        }
    }
</script>

<style scoped>
    table th, table td{
        vertical-align: middle;
        text-align: center;
    }
</style>